import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import validateEmail from "../../helperFunctions/validateEmail";
import { Card, Form, Button } from "react-bootstrap";

export default function ForgotPassword() {
  const [validated, setValidated] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    const emailData = event.currentTarget.firstChild.firstChild.value;
    setEmailError(validateEmail(emailData));

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    event.preventDefault();
    if (form.checkValidity() === true) {
      navigate(`/forgot-password-next?email=${emailData}`);
      // this should call a send email function to emailData
    }
  };
  return (
    <>
      <Card.Title>Forgot Password?</Card.Title>
      <p className="subtitle">
        Enter your email address and we will send you instructions to reset your
        password.
      </p>
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        className="login-form"
      >
        <Form.Group controlId="validationEmail" className="form-group">
          <Form.Control
            required
            type="email"
            placeholder=""
            name="email"
            onChange={validateEmail}
            className="input"
          />
          <Form.Control.Feedback type="invalid">
            <strong>*{emailError}</strong>
          </Form.Control.Feedback>
          <Form.Label>Email</Form.Label>
        </Form.Group>
        <Button type="submit" className="sign-in-button">
          Next
        </Button>
      </Form>
      <Link className="link" to="/">
        Back to login
      </Link>
    </>
  );
}
